import yaml from 'js-yaml';

/**
 * Sort object keys recursively for stable YAML output (git-friendly diffs).
 */
export function sortKeysDeep(value) {
  if (Array.isArray(value)) {
    return value.map(sortKeysDeep);
  }
  if (value && typeof value === 'object' && !(value instanceof Date)) {
    return Object.keys(value)
      .sort()
      .reduce((acc, key) => {
        acc[key] = sortKeysDeep(value[key]);
        return acc;
      }, {});
  }
  return value;
}

/**
 * Dump YAML with deterministic key ordering and consistent formatting.
 */
export function dumpYaml(data) {
  return yaml.dump(sortKeysDeep(data), {
    lineWidth: 120,
    noRefs: true,
    quotingType: '"',
    forceQuotes: false,
  });
}

/**
 * Parse YAML text safely.
 */
export function parseYaml(text) {
  if (!text || !String(text).trim()) return null;
  return yaml.load(String(text));
}
